import { render } from "./field_settings.vue?vue&type=template&id=23787ebb"
import script from "./field_settings.vue?vue&type=script&lang=js"
export * from "./field_settings.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/field_settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23787ebb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23787ebb', __exports__)) {
    api.reload('23787ebb', __exports__)
  }
  
  module.hot.accept("./field_settings.vue?vue&type=template&id=23787ebb", () => {
    api.rerender('23787ebb', render)
  })

}


export default __exports__